export default __webpack_public_path__ + "static/media/Mercenary's Armbands of the Primeval.5b63f0da.jpg";